<template>
    <div class="knowledge-goods">
        <!-- 标题 -->
        <!-- <div class="goods-title" >
            <div class="title-top"> ｢ {{ itemInfo.itemName }} ｣ </div>
        </div> -->
        <van-nav-bar fixed class="video-title">
            <template #title>
                <div>{{ itemInfo.itemName }}</div>
            </template>
            <template #left v-if="showBack">
                <van-icon name="arrow-left" size="18" @click="onClickLeft" />
            </template>
        </van-nav-bar>
        <!-- 超链接 -->
        <!-- <div class="share-nav" v-if="isFileType == 1">
            <div class="share-list" @click="handlerTo">#博士技术专家案例分享 <span class="icon-share">></span></div>
        </div> -->
        <!-- 付费知识视频或图片 -->
        <div class="article-goods ">
            <!-- {{itemInfo.itemContentImageUri}} -->
            <div class="article-open" v-if="isFileType == 1 ">
              <div  class="flex-article"
                    v-if="userRole !== '03' && orderCount == 0"  @click="directBuy">
                    试看50% 兑换后观看完整内容
                   </div>
                <img :src="getImageUrl(itemInfo.itemContentImageUri)" class="van-img" />

            </div>

            <div class="video-open" v-if="isFileType == 0">
              <div  class="flex-top" @click="directBuy"
                    v-if="userRole !== '03' && orderCount == 0">
                    试看15s，兑换查看完整内容</div>
                <video :src="getImageUrl(itemInfo.itemContentImageUri)" class="van-img2 video-js vjs-big-play-centered"
                    controls controlsList="nodownload"></video>
                <div class="good-name">礼品名称：<span>{{ itemInfo.itemName }}</span></div>
                <div class="good-detail">礼品详情:
                  <div class="sidbar-item-value" v-if="itemInfo.isPromotion === 1">
                  <p class="sidbar-item-basePoint" ><span>{{ itemInfo.firstPointTypeName}}:{{ itemInfo.promotionPoint}}</span></p>
                  <span class="search-result-oldintegration">原积分：{{ itemInfo.basePoint }}</span>
                </div>
                <div class="sidbar-item-value" v-if="itemInfo.isPromotion !== 1">
                  <p class="sidbar-item-basePoint" ><span>{{ itemInfo.firstPointTypeName}}:{{ itemInfo.basePoint }}</span></p>
                </div>
                    <span v-html="itemInfo.itemDesc" ></span>
                </div>

            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="fixed">
            <template>
                <div class="col-25 text-right">
                    <span
                        :class="{'goods-kudos-icon': itemInfo.isSupport == 0, 'goods-kudosed-icon': itemInfo.isSupport == 1}"
                        @click="kudos" v-if="isCourseItem">
                        <div class="collection-write"> {{itemInfo.itemSupportCount}}</div>
                    </span>

                    <span
                        :class="{'goods-collection-icon': itemInfo.isFavorite == 0, 'goods-collectioned-icon': itemInfo.isFavorite == 1}"
                        @click="collection" v-if="isCourseItem">
                        <div class="collection-write">收藏</div>
                    </span>
                    <span class="goods-share-icon" v-if="isCourseItem" @click="handleShare">
                        <div class="collection-write">转发</div>
                    </span>
                    <a v-if="itemInfo.buyLink" :href="itemInfo.buyLink">
                        <van-icon name="weapp-nav" size="20" color="#117281"></van-icon>
                    </a>
                </div>
                <van-button type="primary" class="flex-1" @click="directBuy"
                    v-if="userRole !== '03' && orderCount == 0 && itemInfo.isPromotion !== 1">
                    {{itemInfo.basePoint }}积分兑换</van-button>
                    <van-button type="primary" class="flex-1" @click="directBuy"
                    v-if="userRole !== '03' && orderCount == 0 && itemInfo.isPromotion === 1">
                    立即兑换</van-button>
                <van-button disabled type="primary" class="flex-1" v-if="userRole !== '03' && orderCount == 1 ">已兑换
                </van-button>

            </template>

        </div>
        <van-overlay :show="showOverlay" @click="showOverlay = false" z-index="99">
            <div class="overlay-wrapper">
                <div>
                    点击页面右上角转发<img class="arrow" src="../../assets/images/extra-style/arrow.png">
                </div>
            </div>
        </van-overlay>
        <van-popup v-model="show" round position="bottom" class="popup" :style="{ height: '27%' }" closeable
            get-container="#app" close-icon-position="top-left">
            <div class="pop-up">阅读全文需要消耗易加积分</div>
            <div class="pop-money"> <span class="point-icon"></span>{{itemInfo.basePoint}} </div>
            <van-button type="primary" class="flex-2" @click="payFor">立即支付</van-button>
            <!-- <van-popup v-model="isSure" :style="{ height: '20%',width:'79%' }" class="sureButton" round closeable get-container="#popup"
                close-icon-position="top-left">
                <div class="pop-up2">是否消耗{{itemInfo.basePoint}}积分兑换完整内容？</div>
                <van-button type="primary" size="large" plain hairline class="button-sure" @click="payContent">确定
                </van-button>
                <van-popup v-model="pay" :style="{ height: '20%',width:'80%' }" round closeable get-container="#app"
                close-icon-position="false" >

                <div class="pop-up3">
                    <div class="order"> <span class="order-icon"></span></div>
                    <div>支付成功</div>
                    </div>
                <van-button type="primary" size="large" plain hairline class="order-sure" @click="orderCreate">确定
                </van-button>
            </van-popup>
            </van-popup> -->
        </van-popup>
         <!-- 活动弹窗 -->
         <popUpDisplay :show.sync="popUpDisplay.dialog"  :activityPrize="popUpDisplay.activityPrize" :type="popUpDisplay.type" ></popUpDisplay>
    </div>
</template>

<script>
import { ImagePreview } from 'vant'
import sortApi from '@/api/sort'
import cartApi from '@/api/cart'
import { commonUtils } from '@/utils/common'
import popUpDisplay from '../../components/popup-cards.vue'
import { mapState } from 'vuex'
export default {
  components: {
    popUpDisplay
  },
  data () {
    return {
      showOverlay: false,
      showBack: {
        type: Boolean,
        default: true
      },
      itemId: '',
      imageList: [],
      itemInfo: {},
      orderItems: [],
      orderCount: -1,
      subItemId: -999, // 礼品组选择的礼品id
      userStatus: 1,
      subItemIndex: -1,
      shapeItemIndex: -1,
      colorItemIndex: -1,
      sizeItemIndex: -1,
      isFileType: 5,
      viewStock: true,
      hasSubItems: false,
      itemColorTagList: [],
      itemSizeTagList: [],
      couponId: '',
      activityPrize: {},
      popUpDisplay: {
        dialog: false,
        activityPrize: {},
        type: 'order'
      },
      show: false,
      isShare: false // 是否为转发链接
      // isSure: false,
      // pay:false,
    }
  },

  mounted () {
    this.init()
    if (this.activityPrize) {
      this.popUpDisplay.dialog = true
      this.popUpDisplay.activityPrize = this.activityPrize
    }
    this.initWxJsSdk()
  },
  deactivated () {
    this.isFileType = 5
  },
  watch: {
    'isFileType': {
      handler () { },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl,
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    }),
    // 判断是否线下课程
    isOfflineCourse () {
      return this.itemInfo && this.itemInfo.itemCategory && this.itemInfo.itemCategory.categoryCode === '1031'
    },
    // 判断是否线上课程
    isOnlineCourse () {
      return (this.itemInfo && this.itemInfo.itemCategory && this.itemInfo.itemCategory.parentList &&
                this.itemInfo.itemCategory.parentList.length && this.itemInfo.itemCategory.parentList[0].categoryCode === '1032') || (this.itemInfo && this.itemInfo.itemCategory &&
                    (this.itemInfo.itemCategory.categoryCode === '13003' || this.itemInfo.itemCategory.categoryCode === '501'))
    },
    // 判断是否课程
    isCourseItem () {
      return this.isOfflineCourse || this.isOnlineCourse
    }

  },
  methods: {
    init () {
      this.isShare = this.$route.query.isShare
      this.activityPrize = this.$route.query.activityPrize
      this.itemId = this.$route.query.itemId ? this.$route.query.itemId : this.$route.params.itemId
      this.fromOrderList = this.$route.query.fromOrderList
      this.couponId = this.$route.query.couponId
      this.queryItemInfo()
      this.getClientInfo()
      // this.getOrderInfo()
      this.CarnivalSubmit()
    },
    CarnivalSubmit () {
      let that = this
      let wxUserInfo = JSON.parse(localStorage.getItem('userInfo'))
      console.log('wxUserInfo=================', wxUserInfo)
      let data = {
        clientId: wxUserInfo.clientInfo.clientId,
        clientUserId: wxUserInfo.clientInfo.clientUserId,
        activityKey: 'browsePointsMall'
      }
      cartApi.CarnivalSubmit(data).then(ress => {
        console.log('res===', ress)
        let res = ress.data
        if (res.resultData && res.resultData.msg) {
          console.log('res===', res.resultData.msg)
          that.$toast.success(res.resultData.msg)
        }
      })
    },
    // 微信
    initWxJsSdk () {
      this.itemId = this.$route.query.itemId ? this.$route.query.itemId : this.$route.params.itemId
      //   console.log(window.__wxjs_is_wkwebview)
      // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }

      const url = `${document.location.origin}/v2/knowledge-goods?itemId=${this.$route.query.itemId}`
      const appMessageShare = {
        title: 'BOSCH知识', // 分享标题
        desc: '我兑换了BOSCH知识课程', // 分享描述
        link: url + '&isShare=true', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/images/share/workshop-video-share.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '博世礼品知识专区', // 分享标题
        link: url + '&isShare=true', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/images/share/workshop-video-share.png', // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    // 点击右箭头跳转

    // 点击放大
    previewImage () {
      const imageUrl = commonUtils.getImageUrl(this.itemInfo.itemContentImageUri)
      ImagePreview({
        images: [imageUrl],
        startPosition: 0
      })
    },
    onClickLeft () {
      if (location.href.indexOf('#backHome') !== -1) {
        this.$router.push({ name: 'home-main' })
        return
      }
      if (this.fromOrderList === true) {
        this.$router.push({
          name: 'userOrder'
          // query: { categoryId: 212 }
        })
      } else {
        if (this.isShare) {
          // 转发链接返回上一页
          this.$router.push({
            name: 'home-main',
            query: { categoryId: 212 }
          })
        } else {
          this.$router.go(-1)
        }
      }
    },
    // 客户信息获取
    getClientInfo () {
      const { isActivated, clientStatus, verifyStatus } = this.clientInfo
      if (isActivated === 1 && clientStatus !== '03' && verifyStatus === '01') {
        this.userStatus = 1
      } else if (isActivated === 1 && clientStatus !== '03' && verifyStatus === '02') {
        this.userStatus = 2
      }
    },
    // 查询礼品详情
    queryItemInfo () {
      let params = {
        itemId: this.itemId || ''
      }
      sortApi.queryItemInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          const { itemInfo } = res.data.resultData
          this.itemInfo = itemInfo
          // 是否有礼品组
          if (this.itemInfo.isGroup === 1 && this.itemInfo.subItemVOs !== undefined) {
            this.hasSubItems = true
          }
          if (this.itemInfo.tagReveal && this.itemInfo.itemTagVO && this.itemInfo.itemTagVO.itemTagType) {
            if (this.itemInfo.itemTagVO.itemTagType === '02') {
              this.itemColorTagList = this.itemInfo.itemTagVO.itemTagNameList
            } else if (this.itemInfo.itemTagVO.itemTagType === '03') {
              this.itemSizeTagList = this.itemInfo.itemTagVO.itemTagNameList
            }
          }
          // 判断图片或者视频类型
          if (this.itemInfo.itemContentFileType === 'video/mp4') {
            this.isFileType = 0
          } else if (this.itemInfo.itemContentFileType === 'image/png') {
            this.isFileType = 1
          } else {
            this.isFileType = 1
          }
          this.getItemOrderCount()
        }
      })
    },
    // 兑换课程次数
    getItemOrderCount () {
      let params = {
        itemId: this.itemId || ''
      }
      if (!params.itemId) {
        return
      }
      if (!this.isCourseItem) {
        return
      }
      sortApi.getItemOrderCount(params).then(res => {
        if (res.data.resultCode === '0') {
          const { orderCount } = res.data.resultData
          this.orderCount = orderCount
        }
      })
    },
    // 立即购买
    directBuy () {
      let data = {
        itemQuantity: 1,
        itemId: this.itemId || ''
      }
      if (this.itemInfo.mOQ !== undefined && this.itemInfo.mOQMultiple === undefined) {
        data.itemQuantity = this.itemInfo.mOQ
      } else if (this.itemInfo.mOQMultiple !== undefined && this.itemInfo.mOQ !== undefined) {
        data.itemQuantity = this.itemInfo.mOQMultiple
      } else if (this.itemInfo.mOQMultiple !== undefined && this.itemInfo.mOQ === undefined) {
        data.itemQuantity = this.itemInfo.mOQMultiple
      } else {
        data.itemQuantity = 1
      }
      if (this.userRole === '03') {
        this.$toast('没有下单权限')
        return
      }
      if (this.userStatus === 1) {
        this.$toast('账号待审核')
      } else if (this.userStatus === 2) {
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        })
        if (!this.hasSubItems) {
          cartApi.queryCartBuy(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$router.push({
                name: 'direct_buy',
                query: {
                  itemId: this.itemId,
                  couponId: this.couponId
                }
              })
            }
            this.$toast.clear()
          }).catch(() => { this.$toast.clear() })
        } else {
          if (this.subItemId === -999) {
            this.$toast('请选择礼品种类')
            return
          }
          data.itemId = this.subItemId
          cartApi.queryCartBuy(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$router.push({
                name: 'direct_buy',
                query: {
                  itemId: this.subItemId,
                  couponId: this.couponId
                }
              })
            }
            this.$toast.clear()
          }).catch(() => { this.$toast.clear() })
        }
      }
    },
    // 确认购买
    payFor () {
      this.isSure = true
      if (this.itemInfo.usableStock === 0 && this.itemInfo.logicalStock === 0 && this.itemInfo.isPreOrder === 0) {
        this.$toast('已售完')
        return
      }
      let data = [{
        itemId: this.itemId,
        selected: 1,
        cartId: this.cartId
      }]
      cartApi.checkSettlement(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$router.push({
            name: 'orderCreate',
            params: {
              selectCouponId: this.couponId
            }
          })
        }
      })
    },
    //     orderCreate () {
    //         this.pay = true
    //        }

    // 收藏
    collection () {
      let params = [{
        itemId: this.itemId
      }]
      if (this.itemInfo.isFavorite === 1) {
        // 取消收藏
        sortApi.removeFavorite(params).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('取消收藏成功')
            this.queryItemInfo()
          }
        })
      } else if (this.itemInfo.isFavorite === 0) {
        // 添加收藏
        sortApi.addFavorite(params).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('收藏成功')
            this.queryItemInfo()
          }
        })
      } else {
        this.$toast('收藏成功')
      }
    },
    // 点赞
    kudos () {
      if (this.itemInfo.isSupport === 1) {
        // 取消点赞
        sortApi.removeSupport({
          itemId: this.itemId
        }).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('取消点赞成功')
            this.itemInfo.itemSupportCount--
            this.queryItemInfo()
          }
        })
      } else if (this.itemInfo.isSupport === 0) {
        // 添加点赞
        sortApi.addSupport({
          itemId: this.itemId
        }).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('点赞成功')
            this.itemInfo.itemSupportCount++
            this.queryItemInfo()
          }
        })
      }
    },
    // 转发
    handleShare () {
      this.showOverlay = true
    },

    // 线上课程购买
    onlineCourseBuy () {
      if (!this.itemInfo) {
        return
      }
      if (!this.isOnlineCourse) {
        return
      }
      if (this.userStatus === 1) {
        this.$toast('账号待审核')
        return
      }
      if (this.userRole === '03') {
        this.$toast('没有下单权限')
        return
      }
      if (this.isElearningCourse) {
        cartApi.queryCheckCiam().then(res => {
          if (res.data.resultCode === '0') {
            if (res.data.resultData.isCiam === 'false' && this.itemInfo.itemCategory.categoryCode === '13003') {
              this.dialogCiamOption.dialogCiamShow = true
            } else {
              this.onlineCourseBuyNext()
            }
          }
        })
      } else {
        this.onlineCourseBuyNext()
      }
    }
  }

}
</script>

<style scoped lang="less">
.title-bgc {
    background-color: #fff;
}

.article-goods {
    width: 100%;
     margin-top: 1.24rem;
}

.video-open {
    width: 100%;
    height: 6rem;

.flex-top{
  border-radius: .2rem;
  width: 5.2rem;
  height: .7rem;
  text-align: center;
  cursor: pointer;
  line-height: .7rem;
  background-color: rgba(0, 0, 0, 0.173);
  color: #fffffff5;
  position:fixed;
  top: 1.26rem;
  right: 0.1rem;
  z-index: 10;
}

.good-name {
        font-size: 0.45rem;
        width: 96%;
        line-height: .8rem;
        margin: 0.2rem auto;
    }

    .good-detail {
      font-size: 0.45rem;
        width: 96%;
        line-height: .8rem;
        margin: 0.2rem auto;
        .sidbar-item-value {
        display: flex;
        align-items: flex-end;
        justify-content:flex-start;
        flex-wrap: wrap;
        height: 0.5rem;

        .sidbar-item-basePoint {
          color: #e20015;
          span {
            font-size: 0.4rem;
          }
        }
        .search-result-oldintegration {
          color: #c2c2c2;
          font-size: 0.3rem;
          text-decoration: line-through;
          margin-left: 10px;
        }

        .sidbar-item-usableStock {
          color: gray;
          font-size: 0.2rem;
        }
      }
        .goods-html {
            background-color: white;
            line-height: 2;
            font-size: 0.35rem;
            height: auto;

            p {
                width: 100% !important;
            }

            img {
                width: 100% !important;
            }
        }

        .goods-html-specInfo {
            padding: 0.25rem;
        }

    }
}

.article-open {
    height: 100%;
    width: 100%;
    .flex-article{

  width: 100%;
  height: 4rem;
  text-align: center;
  cursor: pointer;
  line-height: 4.5rem;
  // background-color: rgba(200, 195, 92, 0.179);
  background: linear-gradient(rgba(255, 255, 255, 0),rgba(250, 250, 250, 0.868),rgb(244, 244, 244),rgb(229, 229, 229));
  // color: #117081;
  color: #0d0d0d;
  position: fixed;
  font-weight: 500;
  z-index: 10;
  bottom: 1.6rem;
  right: 0;
  left: 0;
   margin: auto;
}
}

.van-img {
    width: 100%;
    height: 100%;
    // margin-top: .3rem;
    margin-bottom: 1.8rem;
}

.van-img2 {
    width: 100%;
    height: 100%;
    margin-top: -0.12rem;
}

.knowledge-goods {
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

}

.share-nav {
    width: 100%;
    height: 1.6rem;
    margin-top: 1.6rem;
    text-align: center;
    line-height: 1.5rem;

}

.share-list {
    width: 8.2rem;
    height: 1.6rem;
    text-align: left;
    color: #117181;
    line-height: 1.5rem;
    background-color: #F7F7F7;
    margin: auto;

    .icon-share {
        margin-left: 3rem;
    }

}

.col-25 {
    width: 5rem;
}

.title-top {
    width: 8.2rem;
}

.goods-title {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 1.5rem;
    font-size: .45rem;
    text-align: center;

}

.goods-collection-icon {
    display: inline-block;
    width: 0.53rem;
    height: 0.53rem;
    margin: 0rem 0.5rem;
    background: url(https://wx.bosch-extra.com.cn/img/sort/goods-collection-icon.png);
    background-size: contain;
}

.goods-collectioned-icon {
    display: inline-block;
    width: 0.53rem;
    height: 0.53rem;
    margin: 0rem 0.5rem;
    background: url(https://wx.bosch-extra.com.cn/img/collectioned.png);
    background-size: contain;
}

.goods-kudos-icon {
    display: inline-block;
    width: 0.53rem;
    height: 0.53rem;
    margin: 0rem 0.5rem;
    background: url(https://wx.bosch-extra.com.cn/img/sort/support.png);
    background-size: contain;

}

.goods-kudosed-icon {
    display: inline-block;
    width: 0.52rem;
    height: 0.53rem;
    margin: 0rem 0.5rem;
    background: url(https://wx.bosch-extra.com.cn/img/sort/suppported.png);
    background-size: contain;
}

.collection-write {
    color: #117181;
    font-size: .25rem;
    position: fixed;
    bottom: .15rem;
    text-align: center;

}

.goods-share-icon {
    display: inline-block;
    width: 0.56rem;
    height: 0.56rem;
    margin: 0rem 0.5rem;
    background: url(https://wx.bosch-extra.com.cn/img/sort/goods-share-icon.png);
    background-size: contain;
}

.fixed {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.6rem;
    background-color: #F7F7F7;

    .flex-1 {
        height: 1rem;
        margin-right: .5rem;
        border-radius: .2rem;

    }

}

.popup {
    .pop-up {
        width: 4.8rem;
        margin: 1.2rem auto 0.5rem;
        font-size: .4rem;
        font-weight: 600;
    }

    .pop-money {
        font-size: .6rem;
        color: #117181;
        text-align: center;
        font-weight: 600;

        .point-icon {
            display: inline-block;
            width: 0.5rem;
            height: 0.5rem;
            margin: auto;
            background: url(../../assets/images/point.png);
            background-size: contain;
        }

    }

    .flex-2 {
        border-radius: .2rem;
        display: block;
        width: 4rem;
        margin-top: 1.5rem;
        margin: .5rem auto;
    }

    .pop-up2 {
        width: 5rem;
        margin: 1.4rem auto 1.2rem;
        font-size: .35rem;
        font-weight: 550;
    }

    .button-sure {
        color: black;
        border: #dddbdbc9;
        font-size: .38rem;
    }

}

.order-sure {
    color: black;
    border: #dddbdbc9;
    font-size: .38rem;
}

.overlay-wrapper {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    height: 100%;
    line-height: 120px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #fff;

    .arrow {
        padding-left: 10px;
        width: 80px;
    }
}

.pop-up3 {
    width: 1.6rem;
    margin: 1rem auto .65rem;
    font-size: .4rem;
    font-weight: 550;

    .order {
        .order-icon {
            display: inline-block;
            width: 0.5rem;
            height: 0.5rem;
            margin: auto;
            margin-left: .5rem;
            margin-bottom: .4rem;
            background: url(../../assets/images/point.png);
            background-size: contain;
        }
    }

}
</style>
